// extracted by mini-css-extract-plugin
module.exports = {"indicator":"NavbarOptionMessenger_indicator__xY0RC","indicatorLabel":"NavbarOptionMessenger_indicatorLabel__TUy1e"};